import { render, staticRenderFns } from "./GhanaPayroll.vue?vue&type=template&id=5a6a6590&scoped=true&"
import script from "./GhanaPayroll.vue?vue&type=script&lang=js&"
export * from "./GhanaPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a6590",
  null
  
)

export default component.exports